import React, { useEffect, useState } from 'react'
import back from '../../assests/images/back_pg.png'
import email from '../../assests/images/email_icon.svg'
import otp from '../../assests/images/otp.svg'
import { Link } from 'react-router-dom';
function Login() {
           const [scrolled, setScrolled] = useState(false);
           const [Login, SetLogin] = useState(true);
        useEffect(() => {
            const handleScroll = () => {
              setScrolled(window.pageYOffset > 0);
            };
        
            window.addEventListener('scroll', handleScroll);
        
            // Cleanup on unmount
            return () => {
              window.removeEventListener('scroll', handleScroll);
            };
          }, []);
    const IsLogin=()=>{
         SetLogin(!Login)
    }

 const inputs = ["input1", "input2", "input3", "input4", "input5", "input6"];
          const [inputs1, setInputs1] = useState({ input1: "", input2: "", input3: "", input4: "" });
          // Add listeners to each input
          inputs.forEach((id) => {
            const input = document.getElementById(id);
            if (input) {
              addListener(input);
            }
          });
      function addListener(input) {
            input.addEventListener("keyup", (event) => {
              const { key, target } = event; // Destructure key and target from event
              const code = parseInt(target.value, 10);
        
              // Move to the next input on valid number (0-9)
              if (code >= 0 && code <= 9) {
                const next = input.nextElementSibling;
                if (next) next.focus();
              } else {
                target.value = ""; // Clear invalid input
              }
        
              // Handle backspace or delete: move to previous input
              if (key === "Backspace" || key === "Delete") {
                const prev = input.previousElementSibling;
                if (prev) prev.focus();
              }
            });
          }
      const handleChange = (e) => {
        const { id, value } = e.target;
        setInputs1((prevState) => ({
          ...prevState,
          [id]: value, // Dynamically update the specific input's value
        }));
      };
      const Otp1 = Object.values(inputs1).join("");
  return (
    <div>
        {Login?<div className="header navbar-fixed">
                <nav  className={scrolled ? 'scrolled top_nav' : 'top_nav'}>
                    <div className="h_left">
                        <Link to={-1} className="btn_tp icon_sq">
                            <img src={back} alt="back_pg" />
                        </Link>
                        Login/ Signup
                    </div>

                </nav>
            </div>:<div className="header navbar-fixed">
                <nav  className={scrolled ? 'scrolled top_nav' : 'top_nav'}>
                    <div className="h_left">
                        <Link to={-1} className="btn_tp icon_sq">
                            <img src={back} alt="back_pg" />
                        </Link>
                       Otp Verification
                    </div>

                </nav>
            </div>}
        <div class="body_area22">
            <div class="cointainr">
                <div class="column_area">

          {Login?<div class="edit_prfle lft_sc">
                        <img src={email} alt="user" class="login_img"></img>

                        <div className='left_sec'>
                            <p class="ttl_bg">Enter your email address<span className='redd'>*</span></p>
                            
                            <input type="text" placeholder="youremail@abc.com" class="validate input_name" value=""></input>

                            <p class="desc">You will recieve an email with a one-time password.</p>

                            <button class="play_now mrgn0 btn_gren " type="submit" onClick={IsLogin}>Continue</button>
                        </div>
                        
                    </div>:<div class="edit_prfle lft_sc">
                        <img src={otp} alt="user" class="login_img"></img>

                        <div className='left_sec'>
                            <p class="ttl_bg">Enter one-time password<span className='redd'>*</span></p>
                            <p class="desc">A one-time password has been sent to avdesh@gmail.com</p>

                            <p class="desc whte">Enter the 4 digit code we sent you via email to continue.</p>  
                        <div id="inputs" class="d_flx2 gap">
                            <input id="input1" type="number" maxlength="1" value={inputs.input1} onChange={handleChange} class="otp_txt validate input_name"/>
                            <input id="input2" type="number" maxlength="1" value={inputs.input2}
                            onChange={handleChange} class="validate input_name otp_txt"/>
                            <input id="input3" type="number" maxlength="1" value={inputs.input3}
                            onChange={handleChange} class="validate input_name otp_txt"/>
                            <input id="input4" type="number" maxlength="1" value={inputs.input4}
                            onChange={handleChange} class="validate input_name otp_txt"/>
                            <input id="input5" type="number" maxlength="1" value={inputs.input5}
                            onChange={handleChange} class="validate input_name otp_txt"/>
                            <input id="input6" type="number" maxlength="1" value={inputs.input6}
                            onChange={handleChange} class="validate input_name otp_txt"/>
                        </div>
                            

                            <p class="desc">Not your email? / Didn't recieve the code? <br></br><a href='#' className='clr_aqua'>Try Again</a></p>

                            <button class="play_now mrgn0 btn_gren " type="submit">Verify</button>
                        </div>
                        
                    </div>}
              
                </div>
            </div>
        </div>
      
    </div>
  )
}

export default Login
